// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  frui_basedataList:[],
  frui_basedataPage:1,
  frui_basedataSize:10,
  frui_basedataTotal:0,
  frui_basedataById:{},
  frui_basedataModalType:"create",
  frui_basedataModalVisible:false,
  currentFrui_basedata:{},
  getFrui_basedataListPending: false,
  getFrui_basedataListError: null,
  submitFrui_basedataPending: false,
  submitFrui_basedataError: null,
  deleteFrui_basedataPending: false,
  deleteFrui_basedataError: null,
  frui_qpgoodsList:[],
  frui_qpgoodsPage:1,
  frui_qpgoodsSize:10,
  frui_qpgoodsTotal:0,
  frui_qpgoodsById:{},
  frui_qpgoodsModalType:"create",
  frui_qpgoodsModalVisible:false,
  currentFrui_qpgoods:{},
  getFrui_qpgoodsListPending: false,
  getFrui_qpgoodsListError: null,
  submitFrui_qpgoodsPending: false,
  submitFrui_qpgoodsError: null,
  deleteFrui_qpgoodsPending: false,
  deleteFrui_qpgoodsError: null,
  frui_planList:[],
  frui_planPage:1,
  frui_planSize:10,
  frui_planTotal:0,
  frui_planById:{},
  frui_planModalType:"create",
  frui_planModalVisible:false,
  currentFrui_plan:{},
  getFrui_planListPending: false,
  getFrui_planListError: null,
  submitFrui_planPending: false,
  submitFrui_planError: null,
  deleteFrui_planPending: false,
  deleteFrui_planError: null,
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/furui/redux/initialState.js